import { el, numFormat } from '../../lib/dom.js';
import { fieldDate, fieldNum, fieldText } from './widgets.js';
import type { WizardCtx } from './types.js';

export function renderGrunddaten(ctx: WizardCtx, container: HTMLElement): void {
  const g = ctx.p.data.grund;
  const head = el('div', { class: 'step-head' });
  head.append(
    el('div', { class: 'eyebrow' }, 'Schritt 1 von 7'),
    el('h2', {}, 'Grunddaten der Parzelle'),
    el(
      'p',
      {},
      'Parzelle und abgebende Pächterin bzw. abgebender Pächter. Alles wird automatisch gespeichert – Sie können jederzeit unterbrechen.',
    ),
  );

  const karte1 = el('div', { class: 'card' });
  karte1.append(el('h3', {}, 'Anlage & Parzelle'));
  const grid1 = el('div', { class: 'grid' });
  grid1.append(
    fieldText(
      'Kleingartenanlage',
      () => g.anlage,
      (v) => (g.anlage = v),
      ctx.save,
      {
        placeholder: 'z. B. Grüffkamp II',
      },
    ),
    fieldText(
      'Parzellen-Nr.',
      () => g.parzelle,
      (v) => (g.parzelle = v),
      ctx.save,
      {
        placeholder: 'z. B. 121',
      },
    ),
    fieldNum(
      'Fläche der Parzelle',
      () => g.flaeche,
      (v) => (g.flaeche = v),
      () => {
        ctx.save();
        ctx.recalc();
      },
      { unit: 'm²', placeholder: '360' },
    ),
    fieldDate(
      'Datum der Begehung',
      () => g.datum,
      (v) => (g.datum = v),
      () => {
        ctx.save();
        ctx.recalc();
      },
      { hint: 'Bestimmt das Bewertungsjahr und damit den Anpassungsfaktor.' },
    ),
  );
  karte1.append(grid1);

  const karte2 = el('div', { class: 'card' });
  karte2.append(el('h3', {}, 'Abgebende Pächterin / abgebender Pächter'));
  const grid2 = el('div', { class: 'grid' });
  grid2.append(
    fieldText(
      'Name, Vorname',
      () => g.paechter,
      (v) => (g.paechter = v),
      ctx.save,
      {
        wide: true,
        placeholder: 'z. B. Meyer, Jaqueline',
      },
    ),
    fieldText(
      'Straße',
      () => g.strasse,
      (v) => (g.strasse = v),
      ctx.save,
      {
        placeholder: 'Hausweg 12',
      },
    ),
    fieldText(
      'PLZ, Wohnort',
      () => g.ort,
      (v) => (g.ort = v),
      ctx.save,
      {
        placeholder: '24105 Kiel',
      },
    ),
    fieldText(
      'Anwesend bei der Begehung',
      () => g.anwesend,
      (v) => (g.anwesend = v),
      ctx.save,
      {
        wide: true,
        placeholder: 'z. B. Pächterin Meyer sowie Müller, Schulze (Kommission)',
      },
    ),
  );
  karte2.append(grid2);

  const info = el('div', { class: 'infochip' });
  info.append(
    el(
      'div',
      {},
      `Anpassungsfaktor ${ctx.p.jahr}: ${numFormat(ctx.p.faktor)} – wird jährlich vom Landesverband festgelegt und fließt automatisch in alle Richtwerte ein.`,
    ),
  );

  container.append(head, karte1, karte2, info);
}
